module.exports = __webpack_public_path__ + "img/asia-admin09.224d5387.png";